export { default } from "./getIdentifier";
